import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Space, Table, Tabs, Tag, Upload } from 'antd';
import Column from 'antd/es/table/Column';
import type { UploadFile, UploadProps } from 'antd/es/upload/interface';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import { QuaTrinhDaoTaoResponse } from '../../models/daotao/QuaTrinhDaoTao';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { TrinhDoHocVanResponse } from '../../models/nhanvien/TrinhDoHocVan';
import { TimKiemToBanResponse } from '../../models/toban/ToBan';
import { luuTrinhDoHocVan, xoaTrinhDoHocVan } from '../../services/nhanvien';
import ChuyenNganhDaoTaoSelectBox from '../utils/ChuyenNganhDaoTaoSelectBox';
import HinhThucDaoTaoSelectBox from '../utils/HinhThucDaoTaoSelectBox';
import HocHamSelectBox from '../utils/HocHamSelectBox';
import XepLoaiTotNghiepSelectBox from '../utils/XepLoaiTotNghiepSelectBox';
const QuaTrinhDaoTaoVaHocVanBox = ({ listHocVan, listDaoTao, listToBan, idNhanVien, isThemMoi, onSubmit }: { listHocVan?: Array<TrinhDoHocVanResponse>, listDaoTao?: Array<QuaTrinhDaoTaoResponse>, listToBan?: Array<TimKiemToBanResponse>, idNhanVien: number, isThemMoi?: boolean, onSubmit: () => void }) => {
    var dataHocVan = (listHocVan || []).map((item: any, index) => { item.key = index; return item; });
    var dataDaoTao = (listDaoTao || []).map((item: any, index) => { item.key = index; return item; });
    var dataToBan = (listToBan || []).map((item: any, index) => { item.key = index; return item; });

    const menu: any = menuHelper.checkMultiPermission([Links.DaoTao.Xem, Links.ToBan.Xem]);
    const [currentTab, setCurrentTab] = useState<number>(1);
    const [loading, setLoading] = useState(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [form] = Form.useForm();
    const [selectedTDHV, setSelectedTDHV] = useState<TrinhDoHocVanResponse>(new TrinhDoHocVanResponse);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    useEffect(() => {
        var fileHienTai: any = (selectedTDHV?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
            };
        });
        setFileList(fileHienTai)
    }, [selectedTDHV]);

    const setFormDetailModalHocVan = (value: TrinhDoHocVanResponse | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idNhanVien": idNhanVien,
            "ngayBatDau": value?.ngayBatDau ? dayjs(dateCommon.formatDate(value?.ngayBatDau), "DD/MM/YYYY") : null,
            "ngayKetThuc": value?.ngayKetThuc ? dayjs(dateCommon.formatDate(value?.ngayKetThuc), "DD/MM/YYYY") : null,
            "idHocHam": value?.idHocHam,
            "idChuyenNganhDaoTao": value?.idChuyenNganhDaoTao,
            "idHinhThucDaoTao": value?.idHinhThucDaoTao,
            "idXepLoaiTotNghiep": value?.idXepLoaiTotNghiep,
            "coSoDaoTao": value?.coSoDaoTao || "",
        });
        setShowModalChiTiet(true);
    }
    const props: UploadProps = {
        onRemove: (file) => {
            if (isThemMoi) {
                if (file.uid.includes("tailieu")) {
                    var id = parseInt(file.uid.split("tailieu")[0]);
                    setIdsTaiLieuXoa([...idsTaiLieuXoa, id]);
                }
                const index = fileList.indexOf(file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);
                setFileList(newFileList);
            }
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };
    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            await luuTrinhDoHocVan(values, fileList, idsTaiLieuXoa);
            setShowModalChiTiet(false);
            setSelectedTDHV(new TrinhDoHocVanResponse);
            toast.success('Lưu trình độ học vấn thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }

        setLoading(false);
        onSubmit();
    };

    const onDelete = async () => {
        try {
            setLoading(true);
            await xoaTrinhDoHocVan(idXoa);
            toast.success('Xoá trình độ học vấn thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setLoading(false);
        onSubmit();
    }
    return (
        <div className="card-outline">
            {idXoa > 0 && <ModalTextForm show={idXoa > 0}
                title="Xoá trình độ học vấn"
                handleClose={() => setIdXoa(0)}
                handleSave={onDelete}>
                Xác nhận xóa trình độ học vấn đang chọn
            </ModalTextForm>}
            {showModalChiTiet && currentTab == 1 ? <ModalTextForm title="Quản lý trình độ học vấn"
                hideFooter
                show={showModalChiTiet}
                handleClose={() => { setShowModalChiTiet(false); setSelectedTDHV(new TrinhDoHocVanResponse); }}
            >
                {
                    isThemMoi ? <Form
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinish}
                        form={form}
                    >
                        <Form.Item hidden name="id"><Input /></Form.Item>
                        <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Từ ngày"
                                    name="ngayBatDau"
                                >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Từ ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Đến ngày"
                                    name="ngayKetThuc"
                                >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Từ ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="idHocHam" label="Trình độ đào tạo" rules={[{ required: true }]}>
                                    <HocHamSelectBox onChange={() => { }} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="idChuyenNganhDaoTao" label="Chuyên ngành đào tạo" rules={[{ required: true }]}>
                                    <ChuyenNganhDaoTaoSelectBox onChange={() => { }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="idHinhThucDaoTao" label="Hình thức đào tạo" rules={[{ required: true }]}>
                                    <HinhThucDaoTaoSelectBox onChange={() => { }} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="idXepLoaiTotNghiep" label="Xếp loại tốt nghiệp" rules={[{ required: true }]}>
                                    <XepLoaiTotNghiepSelectBox onChange={() => { }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item name="coSoDaoTao" label="Cơ sở đào tạo" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Row>
                            <Col span="24">
                                <Upload {...props}>
                                    <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                </Upload>
                            </Col>
                        </Row>
                        <Form.Item>
                            <Button type="primary" className="float-right mt-2" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                                Lưu
                            </Button>
                        </Form.Item>
                    </Form>
                        : <>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Từ ngày</div>
                                        <label>{selectedTDHV?.ngayBatDau != null ? dateCommon.formatDate(selectedTDHV?.ngayBatDau) : ""}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Đến ngày</div>
                                        <label>{selectedTDHV?.ngayKetThuc != null ? dateCommon.formatDate(selectedTDHV?.ngayKetThuc) : ""}</label>
                                    </div>                                 
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Trình độ đào tạo</div>
                                        <label>{selectedTDHV?.tenHocHam}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Chuyên ngành đào tạo</div>
                                        <label>{selectedTDHV?.tenChuyenNganhDaoTao}</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Hình thức đào tạo</div>
                                        <label>{selectedTDHV?.tenHinhThucDaoTao}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className="mb-1">
                                        <div>Xếp loại tốt nghiệp</div>
                                        <label>{ selectedTDHV?.tenXepLoaiTotNghiep}</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <div className="mb-1">
                                        <div>Cơ sở đào tạo</div>
                                        <label>{selectedTDHV?.coSoDaoTao}</label>
                                    </div>
                                </Col>
                            </Row>                            
                            <Row>
                                <Col span="24">
                                    <div className="mb-1">
                                        <div>File đính kèm</div>
                                        <Upload disabled={true} {...props}>
                                        </Upload>
                                    </div>                                    
                                </Col>
                            </Row>
                        </>
                }
            </ModalTextForm> : null}
            <Tabs tabBarExtraContent={isThemMoi && currentTab == 1 ?
                <Button
                    className="hrm-btn hrm-btn-warning"
                    onClick={() => {
                        setFormDetailModalHocVan(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
                : null} defaultActiveKey="1" onChange={(e: any) => setCurrentTab(e)} items={[
                    {
                        key: '1',
                        label: 'Trình độ học vấn',
                        children:
                            <div className="card">
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={dataHocVan}
                                    pagination={false}
                                    rowClassName={(record, index) => {
                                        return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                    }}
                                >

                                    <Column
                                        title="STT"
                                        key="STT"
                                        render={(value, record, index) =>
                                        (
                                            <>
                                                {index + 1}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Từ ngày"
                                        key="tungay"
                                        render={(value: TrinhDoHocVanResponse, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.ngayBatDau)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Đến ngày"
                                        key="denngay"
                                        render={(value: TrinhDoHocVanResponse, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.ngayKetThuc)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column title="Trình độ đào tạo" dataIndex="tenHocHam" key="tenHocHam" />
                                    <Column title="Chuyên ngành đào tạo" dataIndex="tenChuyenNganhDaoTao" key="tenChuyenNganhDaoTao" />
                                    <Column title="Hình thức đào tạo" dataIndex="tenHinhThucDaoTao" key="tenHinhThucDaoTao" />
                                    <Column title="Cơ sở đào tạo" dataIndex="coSoDaoTao" key="coSoDaoTao" />
                                    {isThemMoi ?
                                        <Column width="10%" title="" key="action"
                                            render={(value: TrinhDoHocVanResponse, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                        icon=<EditOutlined rev="" />
                                                        onClick={() => { setFormDetailModalHocVan(value); setSelectedTDHV(value) }}
                                                    >
                                                        Sửa
                                                    </Button>
                                                    <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                        onClick={() => { setIdXoa(value.id) }}
                                                        icon=<DeleteOutlined rev="" />
                                                    >
                                                        Xóa
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        /> :
                                        <Column width="10%" title="" key="action"
                                            render={(value: TrinhDoHocVanResponse, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Xem"
                                                        icon=<EyeOutlined rev="" />
                                                        onClick={() => { setFormDetailModalHocVan(value); setSelectedTDHV(value) }}
                                                    >
                                                        Xem
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        />
                                    }
                                </Table>
                            </div>
                    },
                    {
                        key: '2',
                        label: 'Quá trình đào tạo',
                        children:
                            <div className="card">
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={dataDaoTao}
                                    pagination={false}
                                >
                                    <Column
                                        title="STT"
                                        key="STT"
                                        render={(value, record, index) =>
                                        (
                                            <>
                                                {index + 1}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Từ ngày"
                                        key="tungay"
                                        render={(value: QuaTrinhDaoTaoResponse, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.ngayBatDau)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Đến ngày"
                                        key="denngay"
                                        render={(value: QuaTrinhDaoTaoResponse, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.ngayKetThuc)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column title="Tên khóa đào tạo" dataIndex="tenLopDaoTao" key="tenLopDaoTao" />
                                    <Column title="Hình thức đào tạo" dataIndex="tenHinhThucToChuc" key="tenHinhThucToChuc" />
                                    <Column title="Đơn vị đào tạo" dataIndex="donViDaoTao" key="donViDaoTao" />
                                    {menu[Links.DaoTao.Xem] &&
                                        <Column
                                            title=""
                                            key="action"
                                            render={(value: QuaTrinhDaoTaoResponse, record, index) =>
                                            (
                                                <div className="action">
                                                    <Link key={"xem" + index} title="Xem chi tiết lớp đào tạo" className="hrm-btn hrm-btn-sm  btn-primary" to={`${Links.DaoTao.Xem}?id=${value?.idLopDaoTao}`}>Xem</Link>
                                                </div>
                                            )
                                            }
                                        />}
                                </Table>
                            </div>
                    },
                    {
                        key: '3',
                        label: 'Danh sách tổ ban',
                        children:
                            <div className="card">
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={dataToBan}
                                    pagination={false}
                                >
                                    <Column
                                        title="STT"
                                        key="STT"
                                        render={(value, record, index) =>
                                        (
                                            <span key={"stt" + index}>
                                                {index + 1}
                                            </span>
                                        )
                                        }
                                    />
                                    <Column title="Tên tổ ban" dataIndex="ten" key="ten" />
                                    <Column title="Số quyết định" dataIndex="soQuyetDinh" key="soQuyetDinh" />
                                    <Column
                                        title="Ngày ký quyết định"
                                        key="ngayBatDau"
                                        width={"210px"}
                                        render={(value, record, index) =>
                                        (<span key={"ngayKyQuyetDinh" + index}>
                                            {dateCommon.formatDate(value?.ngayKyQuyetDinh)}
                                        </span>
                                        )

                                        }
                                    />
                                    <Column align="center" title="SL thành viên" dataIndex="soLuongNhanVien" key="soLuongNhanVien" />
                                    <Column align="center" title="Chức danh" dataIndex="chucDanh" key="chucDanh" />
                                    <Column
                                        title="Trạng thái"
                                        key="trangThai"
                                        render={(value, record, index) =>
                                        (
                                            <Tag color={value.trangThai == 1 ? "green" : "red"}>{value.trangThai == 1 ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                                        )
                                        }
                                    />
                                    {menu[Links.ToBan.Xem] &&
                                        <Column
                                            title=""
                                            key="action"
                                            render={(value, record, index) =>
                                            (
                                                <div className="action">
                                                    <Link key={"xem" + index} title="Xem chi tiết tổ ban" className="hrm-btn hrm-btn-sm  btn-primary" to={`${Links.ToBan.Xem}?id=${value?.id}`}>Xem</Link>
                                                </div>
                                            )
                                            }
                                        />}
                                </Table>
                            </div>
                    }
                ]}>
            </Tabs>
        </div>
    );
};

export default QuaTrinhDaoTaoVaHocVanBox;
